// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"86":"fa1c96f7","162":"e6e6d973","388":"c1077bfa","663":"f93f36f0","742":"bfc1a566","823":"71d1cceb","968":"9d9c3104"}[chunkId] + ".chunk.js";
};